// extracted by extract-css-chunks-webpack-plugin
module.exports = {"listMsgBox":"El994"};